<mf-page title="Reportes para BCU">
  <mf-row>
    <mf-grid
      #grid
      actionButtonText="Nuevo reporte"
      [initialFilters]="filters"
      [apiEndpoint]="apiEndpoint"
      [columns]="columns"
      [menuItems]="menuItems"
      [mustIncludeFields]="mustIncludeFields"
      (actionButtonClick)="openBcuReportPopup()" />
  </mf-row>
</mf-page>
